import { render } from "./ShowBooks.vue?vue&type=template&id=e301adb0&scoped=true"
import script from "./ShowBooks.vue?vue&type=script&lang=js"
export * from "./ShowBooks.vue?vue&type=script&lang=js"

import "./ShowBooks.vue?vue&type=style&index=0&id=e301adb0&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e301adb0"]])

export default __exports__